















import Vue from 'vue';
import Component from 'vue-class-component';
import ProfileIcon from '@/assets/icon/profile.svg';
import CloudProfileIcon from '@/assets/icon/cloud-profile.svg';

@Component({})
export default class Login extends Vue {
  public ProfileIcon = ProfileIcon;
  public CloudProfileIcon = CloudProfileIcon;

  public openModal() {
    this.$emit('openModal', 'login');
  }
}
